// services/location_service.js
export default class LocationService {
  constructor(onUpdate, onError) {
    this.watchId = null
    this.isTracking = false
    this.onUpdate = onUpdate
    this.onError = onError

    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ action: 'location_init' }));
    }
  }

  startTracking() {
    if (window.ReactNativeWebView) {
      if (!this.isTracking) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ action: 'location_start' }));
        this.isTracking = true;
      }
      return;
    }

    if (this.watchId) return

    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    }

    this.watchId = navigator.geolocation.watchPosition(
      this.onUpdate,
      this.onError,
      options
    )
    this.isTracking = true
  }

  async stopTracking() {
    if (window.ReactNativeWebView) {
      if (this.isTracking) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ action: 'location_stop'}));
        this.isTracking = false;
      }
      return;
    }

    if (this.watchId) {
      navigator.geolocation.clearWatch(this.watchId)
      this.watchId = null
      this.isTracking = false
    }
  }

  get isActive() {
    return this.isTracking
  }

  async requestDevicePermissions() {
    try {
      // Request GPS permission with high accuracy
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        });
      });
  
      console.log('Device permissions granted');
      return true;
    } catch (error) {
      console.error('Error requesting device permissions:', error);
      return false;
    }
  }
}
